import React,{Component} from 'react';
import * as ShipConstants from '../../../Global/Constants';
import LeftNav from "./LeftNav";
import BreadCrumbs from "../../../Components/UI/BreadCrumbs";
import Wrp from "../../../hoc/Wrp/Wrp";
import { connect } from 'react-redux';
import * as actions from '../../../store/actions';
import { withRouter } from 'react-router';
import CreateNewVariable from './ExcelContent/CreateVariable';
import FieldContent from './ExcelContent/FieldContent';
import { deleteViolationsMsg } from '../../../Utils/CommonFunctions';
import Calculation from './ExcelContent/Calculation';
import { getCurrentModuleId } from '../../../Utils/UserFunctions';
import http from '../../../services/http';

class ExcelCreate extends Component {

	state = {
		isAddFields:false,
		breadCrumbs:{},
		excelDetail:null,
		isSideBarOpen:false,
		variableList:[],
		variableListBackup:[],
		isVariableModalOpen:false,
		variablesAndFields:[],
		windowsList:[],
		isCalculationOpen:false,
		payload:{
			active:false,
			isDefault:false,
			description:'',
			excel_template_fields:[],
			name:'',
			profile_id:'',
			users:[],
			shared:false,
			layout_id:'',
			window_id:''
		},
		formulaData:{
			functionType:0,
			functionObj:null,
			functionVal:'',
			formula_expression:'',
			operator:'',
			fieldVal:'',
			currentIndex:'',
			formula_returntype:''
		},
		editData:{},
		drillDownData:[],
		metaInfo:null,
		windowFields:[],
		windowFieldsExist:[],
		tableRecords:{
			tableData:[],
			pagination:{
				search:"",
				perPage:10,
				page:0,
				orderBy:"",
				totalRecords:0
			}
		},
		response:false
	}

	componentWillMount() {
	  	const params = this.props.match.params;
	  	this.setState({
	      breadCrumbs: {
	          backHistory : [{
	          href : "/settings",
	          name:"Settings"
	          },{
	          href : "/excel/excel-list",
	          name:"Excel Template List"
	          }],
	          pageTitle:"Excel Template",
	          buttonList:[
        	  	{
	              href:"/excel/excel-list",
	              name:"Cancel",
	              attributes:{
	                className:"btn secondary_bg mr-1 ml-1"
	              },
	              type:"cancel",
	              icon:"fas fa-plus smoky_light_color",
	            },
	        	  {
	              href:"",
	              attributes:{
	                className:"btn primary_bg"
	              },
	              name:"Save",
	              type:"save",
	              clickHandler:this.saveHandler.bind(this,false)
	          	}
	          ]
	      }
	    });
		this.recordsChangeHandler()
	    this.fetchVariableList();
	    this.variableAndFieldList();
	    this.fetchWindowList();
  		this.getXLFileData(params.excelTemplateId);
  		this.fetchFormulaFieldMetaInfo();
  	}
	  getMappingData=()=>{
		const {payload} = this.state;
  		const params = this.props.match.params;
  		const body = {
  			windowId: payload.window_id,
  			layoutId:payload.layout_id,
  			profileId:payload.profile_id,
    	}
    	let viol = this.state.violations ? this.state.violations : {};
    	let isError = false;
    	if(payload.layout_id === '') {
    		viol['layout_id'] = "Layout is Missing";
    		isError = true;
    	}
    	if(payload.shared === true && payload.profile_id === '') {
    		viol['profile_id'] = "Profile is Missing";
    		isError = true;
    	}
    	if(isError === true) {
    		this.setState({violations:viol});
    		return false;
    	}
    	this.props.Loader();
    	const requestParam = '?windowId='+payload.window_id+'&layoutId='+payload.layout_id+'&profileId='+payload.profile_id;
  		http.POST("excel/template/fields/auto-mapping"+requestParam,body).then(res => {
			this.props.Loader(false);
	    	const response = res.data;
		    if(response.code===ShipConstants.API_STATUS_SUCCESS){
		    	console.log(response.data);
		      	const updateState = {...this.state};
		      	
		      	if(response.data) {
		      		response.data.map((item,ind) => {
		      			item.window_field=[{field_name:item.window_field_name_path}]
		      		})
		      		updateState.payload.excel_template_fields = response.data;
					  updateState.isAddFields= !updateState.isAddFields;
		      		this.setState(updateState);
		      	}
			}else{
				let viol = {};
		      	let errMsg = '';
		      	if(response.violations && response.violations.length > 0) {
		      		let isTmeplateEmpty = false;
		      		response.violations.map((arr,ind) => {
		      			if(arr.field_name === 'excel_template_fields') {
		      				isTmeplateEmpty = true;
		      			}else {
		      				const data = arr.field_name+':'+arr.message;
			      			const key = arr['field_name'].replace(/['"]+/g, '');
			      			viol[key]= arr['message'];
			      			errMsg += ind === 0 ? data : ', '+data;
		      			}
		      		})
		      		if(isTmeplateEmpty === true && Object.keys(viol).length === 0) {
		      			this.props.failMessage("Excel Template Field is empty");
		      		}
		      		this.setState({violations:viol});
		      	}else {
			      	this.props.failMessage(response.message+"<br/>"+errMsg);
		      	}
			}
    	}, (error) => {
			this.props.Loader(false);
		});
	  }

	//Delete Variable Api Call Execute
	deleteVaraibleHandler = (id) => {
		this.props.Loader();
		http.DELETE("rates/variables/"+id+"/delete")
		.then(response => {
			this.props.Loader();
			const responseData = response.data;
			if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
				this.recordsChangeHandler()
				this.fetchVariableList();
			this.props.succMessage(responseData.message);
			}else {
			this.props.failMessage(responseData.message);
			}
		})
	}
	editToogleCreateNewHandler = (data)=>{
		const {isVariableModalOpen} = this.state;
		this.setState({editData:data,isVariableModalOpen:!isVariableModalOpen});
	  }
  	render() {
  		const {response,variableList,isVariableModalOpen,variablesAndFields,windowsList,excelDetail,isAddFields} = this.state;
  		// console.log(excelDetail);
		return(
		<Wrp>
			<BreadCrumbs breadCrumbsList={this.state.breadCrumbs} />
			<div className="viewport">
		        <div className="view view-xl"> 
		          {/* <div className="card_Box wizard wizard-2">
		          	<div className="card_Body p-0">
						<div className="view view-xl"> */}
							<div className="portTwoSection">
								{excelDetail && excelDetail.variable_mapping === true ?
									<LeftNav
										response={response}
										recordsChangeHandler={this.recordsChangeHandler}
										pagination={this.state.tableRecords.pagination}
										updateSearch={this.updateSearch}
										submitSearch={this.submitSearch}
										toggleSideBar={this.toggleSideBar}
										toggleVariableModel={this.toggleVariableModel}
										deleteVaraibleHandler = {this.deleteVaraibleHandler}
										editToggleModel={this.editToogleCreateNewHandler}
										variableList={this.state.tableRecords.tableData}
									/>
								: null}
								{ isAddFields === true || (excelDetail && excelDetail.excel_template_fields.length>0) ?
								<div className="view view-xl">
									<div className="outerPort" style={{top:"5px", left:"0px"}}>
									<FieldContent 
									addNewRow={this.addNewRow}
									payload={this.state.payload}
									variableList={variableList}
									drillDownChangeHandler={this.drillDownChangeHandler}
									valueChangeHandler={this.valueChangeHandler}
									toggleCalculation={this.toggleCalculation}
									deleteRow={this.deleteRow}
									windowFields={this.state.windowFields}
									/>
									</div>
								</div>
								:
								<div className="view view-xl">
									<div className="table_Box dataTables_wrapper">
										<div className="table_Body d-flex align-items-center justify-content-center">
											<div className=" text-center">
											<h5 className=""> Fill the Mandatory Fields to Proceed Further </h5>
											<div className="btn-group">
												<button type="button" className="btn third_bg" onClick={this.getMappingData}> Auto Generate </button>
												<button type="button" className="btn primary_bg" onClick={this.addNewRow.bind(this,true)}>  Add New </button>
												</div>
											</div>
										</div>
									</div>
								</div>}
							</div>
						{/* </div>
					</div>
		          </div> */}
		        </div>
	      	</div> 
	      	<CreateNewVariable
	        	isVariableModalOpen={isVariableModalOpen}
	        	variablesAndFields={variablesAndFields}
	        	windowsList={windowsList}
	        	toggleVariableModel={this.toggleVariableModel}
	        	variableList={variableList}
				recordsChangeHandler={this.recordsChangeHandler}
	        	fetchVariableList={this.fetchVariableList}
				editData={this.state.editData}
	        	{...this.props}
	        />
	        <Calculation
		      	{...this.props} 
				currState={this.state} 
				toggleCalculation={this.toggleCalculation}
				formulaDataChangeHandler={this.formulaDataChangeHandler}
				drillDownNextLevel={this.drillDownNextLevel}
				goBackDrillDown={this.goBackDrillDown}
				saveCalculation={this.saveCalculation}
		      />
		</Wrp>
		)
	}

	toggleSideBar = () => {
		this.setState({isSideBarOpen:!this.state.isSideBarOpen});
	}

	getXLFileData = (ide) => {
	  	// this.props.Loader();
	  	const queryString = '?query=&page=0&orderBy=&size=10&direction=';
	  	const params = this.props.match.params;
	  	const body = {
	    	id : ide
	    }
  		http.POST("excel/templates/paginated-search/"+queryString,body)
	    .then(res => {
      	const response = res.data;
      	if(response.code===ShipConstants.API_STATUS_SUCCESS){
	      	if(response.data.content && response.data.content.length>0) {
	      		let data = response.data.content[0];
	      		if(data.excel_template_fields && Array.isArray(data.excel_template_fields)) {
	      			data.excel_template_fields.map(item => {
	      				let lookupField = [];
		                if(item.window_field_name_path && item.window_field_name_path !== '') {
		                	let res = item.window_field_name_path.split(".");
		                	if(res.length > 0) {
			                    res.map((arr1,ind) => {
			                        lookupField.push({field_name :arr1});
			                    })
		                    }
		                }else if(item.column_name && item.column_name !== ''){
		                	let res = item.column_name.split(".");
		                	if(res.length > 0) {
			                    res.map((arr1,ind) => {
			                        lookupField.push({field_name :arr1});
			                    })
		                    }
		                }
	      				item.window_field = lookupField;
	      			})
	      		}
	      		let users = [];
				if(data.user_names) {
					Object.keys(data.user_names).forEach(function(key) {
					    users.push({id:key,label:data.user_names[key],text:data.user_names[key],value:key});
					});
				}
				data.users = users;
				data.isDefault = data.default;
	      		this.setState({
	      			excelDetail:response.data.content[0],
	      			payload:{
	      				...this.state.payload,
	      				active:data.active,
						isDefault:data.default,
						description:data.description,
						name:data.name,
						profile_id:data.profile_id,
						shared:data.shared,
						excel_template_fields:data.excel_template_fields,
						window_id:data.window_id,
						layout_id:data.layout_id	      			}
	      		});
	      		if(response.data.content[0].variable_mapping === false)
	      			this.genereLayoutFields(response.data.content[0].layout_id,false);
	      	}
	      }
	      // this.props.Loader(false);
	    }, (error) => {
	      this.props.Loader(false);
	    })
	}

 	genereLayoutFields = (id,isLoad=true) => {
	  	const params = this.props.match.params;
		console.log("genereLayoutFields id",id,isLoad);
		if(isLoad === true) { this.props.Loader(); }
		http.GET('layouts/'+id+'/lookup-layouts/EXCEL-Template')
	    .then(windowResponse => {
	        const responseData = windowResponse.data;
	        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
	            this.setState({windowFields:responseData.data,windowFieldsExist:responseData.data})
	        }
	        this.props.Loader(false);
	    }, (error) => {
	    		this.props.Loader(false);
	        console.log(error);
	    })
  }
 		 updateSearch=(e)=>{
			const{value}=e.target
			this.setState({tableRecords:{...this.state.tableRecords,pagination:{...this.state.tableRecords.pagination,search:value}}})
  		}
	  submitSearch=(e)=>{
		e.preventDefault()
	
		const pagination={
			search:this.state.tableRecords.pagination.search,
			page:0,
			perPage:10
		}
		this.recordsChangeHandler(pagination)
	}
	  recordsChangeHandler=(pagination={search:"",perPage:10,page:0})=>{
		const params = this.props.match.params;
		const search=pagination.search
		const perPage=pagination.perPage
		const page=pagination.page
		const query=`?search=${search}&page=${page}&orderBy&size=${perPage}&functionType=PDF&referenceId=${params.excelTemplateId}`
	http.GET(`variable/paginated-search`+query)
	.then(response => {
		const responseData = response.data;			
		if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
		  this.setState({response:true,tableRecords:{...this.state.tableRecords,tableData:responseData.data.content,pagination:{...this.state.tableRecords.pagination,page:page,perPage:perPage,totalRecords:responseData.data.total_elements}}})
		}else{
		  this.setState({response:false,tableRecords:{...this.state.tableRecords,tableData:[]}})
		}
	  }, (error) => {
		this.props.failMessage("Something went wrong..");
	  })
	}

	fetchVariableList = () => {
		const params = this.props.match.params;
	    http.GET("variable/paginated-search?functionType=PDF&referenceId="+params.excelTemplateId)
	    .then(response => {
	      const responseData = response.data;
	      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
	        this.setState({variableList:responseData.data.content,variableListBackup:responseData.data.content})
	      }else{
			this.setState({variableList:[]})
		  }
	    }, (error) => {
	      this.props.failMessage("Something went wrong..");
	    })
  	}

	variableAndFieldList = () => {
	    http.GET("rates/field-type-list")
	    .then(response => {
	      const responseData = response.data;
	      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
	        this.setState({variablesAndFields:responseData.data});
	      }
	    }, (error) => {
	      this.props.failMessage("Something went wrong..");
	    })
  	}

  	fetchWindowList = () => {
		this.props.Loader();
	    http.GET("windows/list?query=&page=0&orderBy=display_name&size=10000&direction=ASC")
	    .then(response => {
	      const responseData = response.data;
	      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
	        this.setState({windowsList:responseData.data.windows.content})
	      }
		  this.props.Loader();
	    }, (error) => {
			this.props.Loader();
	      this.props.failMessage("Something went wrong..");
	    })
  	}	

  	toggleVariableModel = () => {
  		this.setState({isVariableModalOpen:!this.state.isVariableModalOpen});
  	}

	addNewRow = (closeModel=false) => {
  		const updateState = {...this.state};
		  if(closeModel === true){
			updateState.isAddFields= !updateState.isAddFields;
		}
	  	const newRow = {
					column_index:0,
					column_name:'',
					default_value:'',
					value_expression:'',
					window_field_id:'',
					window_field_id_path:'',
					window_field:[]
				}
		updateState.payload.excel_template_fields.push(newRow);
		this.setState(updateState);
  	}

  	drillDownChangeHandler = (fieldData, index) => {
	  	// const params = this.props.match.params;
		if(fieldData) {
	      const fieldCount = fieldData.length;
	      if(fieldCount > 0) {
	          const obj = fieldData[fieldCount-1];
	          let absoluteWindow = '';
	          let formulatExp = this.state.excelDetail && this.state.excelDetail.window_name ? this.state.excelDetail.window_name : "";
	          // if(fieldCount > 1) {
	            fieldData.map((arr,i) => {
	                // if(arr.system_window_name) {
	                   absoluteWindow += i === 0 ? arr.id : '.'+arr.id;
	                    // absoluteWindow += '.'+arr.id;
	                   if(formulatExp === "") {
	                   		formulatExp += i === 0 ? arr.api_field_name : '.'+arr.api_field_name;
	                   }else {
	                   		formulatExp += '.'+arr.api_field_name;
	                   }
	                    
	                // }
	            })
	      		// }
	      	console.log(formulatExp,fieldData)
	        // const filterdata = obj.filters;
	        const fieldType = obj.field_type;
	        const fieldName = obj.field_name;
	        const options = obj.options;
	        const id = obj.id;
	        // const lookupName = obj.lookUpName;
	        // const fieldTypeId = obj.fieldTypeId;
	        let optionsArr = [];
	        if(options.length > 0) {
	          options.forEach((arr,i) => {
	            const value = {
	              "value": arr.key,
	              "label": arr.value,
	            }
	            optionsArr.push(value);
	          }) 
	        }

	        const updateState = {...this.state};
	        updateState.payload.excel_template_fields[index]['window_field_id'] = id;
	        updateState.payload.excel_template_fields[index]['window_field_id_path'] = absoluteWindow;
	        updateState.payload.excel_template_fields[index]['window_field'] = fieldData;
	        updateState.payload.excel_template_fields[index]['column_name'] = fieldName;
	        updateState.payload.excel_template_fields[index]['field_type'] = fieldType;
	        updateState.payload.excel_template_fields[index]['value_expression'] = '${'+formulatExp+'}';

	        if(this.state.violations) {
	        	const violWindow_field_id = 'excel_template_field['+index+'].window_field_id';
	        	const vioColumn_name = 'excel_template_field['+index+'].column_name';
						let viol = deleteViolationsMsg(violWindow_field_id,this.state.violations);
						viol = deleteViolationsMsg(vioColumn_name,viol);
						updateState.violations = viol;
					}

	        this.setState(updateState);
	      }
	    }else {
	    	const updateState = {...this.state};
	      updateState.payload.excel_template_fields[index]['window_field_id'] = '';
	      updateState.payload.excel_template_fields[index]['window_field_id_path'] = '';
	      updateState.payload.excel_template_fields[index]['window_field'] = '';
	      updateState.payload.excel_template_fields[index]['column_name'] = '';
	      updateState.payload.excel_template_fields[index]['field_type'] = '';
	      updateState.payload.excel_template_fields[index]['default_value'] = '';
	      updateState.payload.excel_template_fields[index]['value_expression'] = '';
	      this.setState(updateState);
	    }
  	}

  	valueChangeHandler = (e,index) => {
	  	const {name,value} = e.target;
	  	const updateState = {...this.state};
	    updateState.payload.excel_template_fields[index][name] = value;
	    if(this.state.violations) {
	    	const violationKey = 'excel_template_field['+index+'].'+name;
				let viol = deleteViolationsMsg(violationKey,this.state.violations);
				updateState.violations = viol;
			}
	    this.setState(updateState);
  	}

  	toggleCalculation = (ind='') => {
	  	let existExp = '';
	  	if(ind !== '') {
	  		existExp = this.state.payload.excel_template_fields[ind]['value_expression'];
	  	}
	  	this.setState({isCalculationOpen:!this.state.isCalculationOpen,formulaData:{
				functionType:0,
				functionObj:null,
				functionVal:'',
				operator:'',
				fieldVal:'',
				formula_expression:existExp,
				currentIndex:ind,
				formula_returntype:''
			}});
  	} 

  	fetchFormulaFieldMetaInfo = ( ) => {
	    http.GET("layouts/formulafield-metainfo")
	    .then(response => {
	      const responseData = response.data;
	      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
	         const metaInfo = responseData.data;
	        this.setState({metaInfo:metaInfo})
	      }
	    }, (error) => {
	      this.props.failMessage("Something went wrong..");
	    })
  	}

  	drillDownNextLevel = (parentData) => {
		const prntData = JSON.parse(parentData);
		const {excelDetail} = this.state;	
		const updateState = {...this.state};
		updateState.drillDownData.push(prntData);
		if(excelDetail.variable_mapping === true) {
			updateState.variableList=prntData.fields;
		}else {
			updateState.windowFields=prntData.dependent_layout;
		}
		this.setState(updateState);
	}

	goBackDrillDown = (itemInd) => {
		const {excelDetail} = this.state;	
		const updateState = {...this.state};
	    let existData = updateState.drillDownData;
	    const slicedArray = existData.slice(0, itemInd+1);
	    if(excelDetail.variable_mapping === true) {
		    if(itemInd !== -1) {
		      updateState.drillDownData = slicedArray;
		      if(slicedArray.length > 0) {
		      	updateState.variableList = slicedArray[slicedArray.length-1].fields;
		      }else {
		      	updateState.variableList = this.state.variableListBackup;
		      }
		    }else {
		      updateState.drillDownData = [];
		      updateState.variableList = this.state.variableListBackup;
		    }
		}else {
			if(itemInd !== -1) {
		      updateState.drillDownData = slicedArray;
		      if(slicedArray.length > 0) {
		      	updateState.windowFields = slicedArray[slicedArray.length-1].dependent_layout;
		      }else {
		      	updateState.windowFields = this.state.windowFieldsExist;
		      }
		    }else {
		      updateState.drillDownData = [];
		      updateState.windowFields = this.state.windowFieldsExist;
		    }
		}
	    this.setState(updateState);
	}

	formulaDataChangeHandler = (name,value,obj) => {
	  	const updateState = {...this.state};
	  	updateState.formulaData[name] = value;
	  	if(name === 'functionVal') {
	  		updateState.formulaData['functionObj'] = obj;
	  	}else if(name === 'formula_expression') {
	  		updateState.formulaData['functionType'] = 0;
	  		updateState.formulaData['functionObj'] = null;
	  		updateState.formulaData['functionVal'] = '';
	  		updateState.formulaData['operator'] = '';
	  		updateState.formulaData['fieldVal'] = '';
	  		updateState.formulaData['formula_returntype'] = '';
	  	}
	  	this.setState(updateState);
  	}


	saveCalculation = () => {
		const currentInd = this.state.formulaData.currentIndex;
	  	const formula = this.state.formulaData.formula_expression;

	  	const updateState = {...this.state}
	  	updateState.payload.excel_template_fields[currentInd]['value_expression'] = formula;
	  	updateState.isCalculationOpen = false;
	  	this.setState(updateState);
	}

	saveHandler = (isSaveAndNew=false) => {
	  	const params = this.props.match.params;
	  	const {excelDetail} = this.state;
	  	let data = this.state.payload;
	  	let userIds = [];
	  	if(data.users && Array.isArray(data.users)) {
	  		data.users.map(item => {
	  			userIds.push(item.value);
	  		})
	  	}
	  	data.user_ids = userIds;
	  	if(data.excel_template_fields && Array.isArray(data.excel_template_fields)) {
	  		data.excel_template_fields.map((item,ind) => {
	  			item.column_index = ind+1;
	  			if(data.id && data.id !== '') {
	  				item.template_id = data.id;
	  			}
	  		})
	  	}
	  	// console.log(this.state.excelDetail); return false;
	  	data.window_id = excelDetail.window_id;
	  	data.default = excelDetail.isDefault;
	  	data.module_id= getCurrentModuleId();
	  	data.id=excelDetail.id;
	  	data.variable_mapping=excelDetail.variable_mapping;
	  	data.layout_id = excelDetail.layout_id;
	  	// console.log(JSON.stringify(data)); return false;
	  	this.props.Loader();
	  	http.POST("excel/template/save",data)
		    .then(response => {
		    	this.props.Loader();
		      const responseData = response.data;
		      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
		      	if(responseData.data) {
		      		if(isSaveAndNew === true) {
		      			this.clearForm();
		      		}else {
		      			this.props.history.push("/excel/excel-list");	
		      		}
		      	}
		        this.props.succMessage(responseData.message);
		      }else {
		      	let viol = {};
		      	let errMsg = '';
		      	if(responseData.violations && responseData.violations.length > 0) {
		      		let isTmeplateEmpty = false;
		      		responseData.violations.map((arr,ind) => {
		      			if(arr.field_name === 'excel_template_fields') {
		      				isTmeplateEmpty = true;
		      			}else {
		      				const data = arr.field_name+':'+arr.message;
			      			const key = arr['field_name'].replace(/['"]+/g, '');
			      			viol[key]= arr['message'];
			      			errMsg += ind === 0 ? data : ', '+data;
		      			}
		      		})
		      		if(isTmeplateEmpty === true && Object.keys(viol).length === 0) {
		      			this.props.failMessage("Excel Template Field is empty");
		      		}
		      		this.setState({violations:viol});
		      	}else {
			      	this.props.failMessage(responseData.message+"<br/>"+errMsg);
		      	}
		      }
	    	})
		    .catch(err => {
		      this.props.Loader();
		      this.props.failMessage("Error occured");
		      console.log(err);
		    })
  	}

  	deleteRow = (ind) => {
	  	const updateState = {...this.state};
	  	updateState.payload.excel_template_fields.splice(ind,1);
			this.setState(updateState);
  	}
}

const mapDispatchToProps = dispatch => {
  return {
    Loader : (msg) => dispatch(actions.loader(msg)),
    succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg))
  };
}

export default connect(null, mapDispatchToProps)(withRouter(ExcelCreate));